import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import saveAs from 'file-saver';

@Component({
  selector: 'app-approval-vendor-associate',
  templateUrl: './approval-vendor-associate.component.html',
  styleUrls: ['./approval-vendor-associate.component.scss']
})
export class ApprovalVendorAssociateComponent implements OnInit {

  public vendorList: any = [];
  public userId: any = null;

  public selectedVendor: any = null;
  public showDetailTable: boolean = false;
  public loadingData: boolean = false;
  public vendorAccociateList: any = [];

  public selectedRowForAction: any = null;
  public showActionDialog: boolean = false;

  public menuItems: MenuItem[];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];

  public selectedStatus: any = null;
  public remarks: any = null;
  public actionItems: any = [];
  public ipAddress: any = '000.000.00';


  constructor(
    private loader: AppLoaderService,
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    // private _personalDetalSer: FarmersDetailsService,
    private ipService: IpAddressService,
    // private fb: FormBuilder,
    // private fApplicationService: FarmersApplicationService,
    private vendorService: VendorDashboardService,
    // private jeService: JEService,
    private cryptoJsService: CryptoJsService,
  ) { }

  ngOnInit(): void {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.loadVendorList();
    this.getIP();

    this.menuItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.vendorAccociateList, `Vendor (${this.selectedVendor?.VendorName}) Associate List`);
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.vendorAccociateList, `Vendor (${this.selectedVendor?.VendorName}) Associate List`);
        }
      },
    ];

    this.loadActionItems();
  }

  loadActionItems() {
    setTimeout(() => {
      this.actionItems = [
        {
          status: 'Approve',
          id: 'A'
        },
        {
          status: 'Reject',
          id: 'R'
        }
      ]
    }, 100)
  }

  loadVendorList() {
    this.loader.start();
    this.vendorService
      .getVendorsForAssociateApproval()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();

          if (res.length > 0) {
            this.vendorList = res;

          } else {
            this.vendorList = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res,
            });
          }
        },
        error: (err) => {
          this.vendorList = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }


  onSelectVendor() {
    this.showDetailTable = true;
    this.vendorAccociateList = [];
    if (this.selectedVendor) {
      this.loadVendorData();
    }

  }

  loadVendorData() {
    // this.loader.start();
    this.loadingData = true;
    this.vendorService
      .getAssociatesByVendorId(this.selectedVendor?.VendorRegId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          // this.loader.close();
          this.loadingData = false;

          if (res.length > 0) {
            this.vendorAccociateList = res;

          } else {
            this.vendorAccociateList = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res,
            });
          }
        },
        error: (err) => {
          this.vendorAccociateList = [];
          // this.loader.close();
          this.loadingData = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "Vendor Associate Id": d.VendorAssociateId,
          "Name": d.Name,
          "AadharNo": d.AadharNo,
          "Mobile No": d.Mobile,
          "WorkType": d.WorkType,
          // "Photo": d.Photo,
          // "Signature": d.Signature,
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'VendorAssociateId', header: 'Vendor Associate Id' },
      { field: 'Name', header: 'Name' },
      { field: 'AadharNo', header: 'Aadhar No' },
      { field: 'Mobile', header: 'Mobile No' },
      { field: 'WorkType', header: 'WorkType' },
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }

  onClickActionRow(val) {
    if (val?.ApprovalStatus != 'Pending') {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Application already approved.',
      });
    }
    this.selectedRowForAction = val;
    this.showActionDialog = true;

  }

  onCloseActionDialog() {
    this.showActionDialog = false;
    this.selectedRowForAction = null;
    this.remarks = null;
    this.selectedStatus = null;
  }

  onClickSubmit() {

    if (this.remarks == null || this.remarks == '') {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning Message',
        detail: 'Add Remark',
      });

      return;
    }

    // public int VendorAssociateId { get; set; }
    //         public string Status { get; set; }
    //         public string Remarks { get; set; }
    //         public string UserId { get; set; }
    //         public string Network_Id { get; set; }
    //         public string Terminal_Id { get; set; }

    let reqBody = {
      VendorAssociateId: this.selectedRowForAction?.VendorAssociateId,
      Status: this.selectedStatus?.id,
      Remarks: this.remarks,
      UserId: this.userId,
      Network_Id: this.ipAddress,
      Terminal_Id: this.ipAddress
    }

    this.submitAssociateAction(reqBody);
  }

  submitAssociateAction(reqBody) {
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.vendorService
      .insertVendorAssociateApprovalStatus(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();

          if (res == 'Record inserted successfully.') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: 'Details submitted successfully.',
            });

            this.onCloseActionDialog();
            this.loadVendorData();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res,
            });
          }
          this.activityRecordService.activityRecord(this.userId, 'Action Associate Data', this.userId, new Date(), `${res}`, JSON.stringify(reqBodyFinal));
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.userId, 'Action Associate Data(Error)', this.userId, new Date(), `${err}`, JSON.stringify(reqBodyFinal));
        },
      });
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }

  rowBackgroundColor(row) {
    if (row.ApprovalStatus == 'Pending') {
      return '#ff8080';
      // if (row.PendingCompletedDays <= -2) {
      // } else if (row.PendingCompletedDays == -1) {
      //   return '#ffc966';
      // }
    } else if (row.ApprovalStatus == 'Approved') {
      return '#99e699';
      // if (row.PendingCompletedDays >= -1) {
      // } else if (row.PendingCompletedDays <= -2) {
      //   return '#ffb3b3';
      // }
    } else return '#ffffff';
  }
}
